<div
  dndEffectAllowed="copyMove"
  dndType="group-v2"
  [dndDraggable]="disableGroupDrag() || isProcessGroup() ? null : { groupId: group().taskGroup.id }"
  [dndDisableIf]="disableGroupDrag() || isProcessGroup()"
  class="list-tasks-group"
>
  @if (!disableGroupDrag() && !isProcessGroup()) {
    <div dndHandle class="list-tasks-group__draggable">
      <img width="15" src="./assets/img/ic-sortdragchange.svg" alt="drag-drop" />
    </div>
  }

  <div class="list-tasks-group__wrapper">
    <div class="list-tasks-group__header">
      <div class="list-tasks-group__header__title">
        <div class="mr-2 list-tasks-group__header__title-edit">
          @if (canEditGroupName) {
            <img
              class="cursor-pointer"
              [src]="'./assets/img/ic-edit-' + (canEditGroupName ? '3' : '3-grey') + '.svg'"
              (click)="onEditGroupName()"
              alt="edit"
            />
          }
        </div>

        <h4>
          @if (isTemplateGroup()) {
            {{ 'ProjectsDashboard.stageTasks.processTasksGroupLabel' | translate }}
          } @else {
            {{ group().taskGroup.name === 'general' ? 'Allgemein' : group().taskGroup.name }}
          }
        </h4>

        <span>{{ groupCompletedCount() }}/{{ groupTotalCount() }}</span>
      </div>

      <div class="list-tasks-group__header__actions">
        @if (isTemplateGroup()) {
          <!-- TODO: Temporary hidden, unlock when client ready -->
          <!-- <button type="button" class="list-tasks-group__header__add" [matMenuTriggerFor]="templateAddMenu">
            <img src="./assets/img/ic-plus-add.svg" alt="add" />
          </button>

          <mat-menu #templateAddMenu="matMenu" xPosition="before" class="menu-v2">
            @for (item of templateAddMenuItems; track item.key) {
              <button mat-menu-item (click)="onTemplateAddOptionSelected(item.key)">
                <span>{{ item.translationKey | translate }}</span>
              </button>
            }
          </mat-menu> -->
        } @else {
          <button type="button" class="list-tasks-group__header__add" (click)="openAddTask()">
            <img src="./assets/img/ic-plus-add.svg" alt="add" />
          </button>
        }
      </div>
    </div>

    <div
      class="list-tasks-group__content"
      [dndDropzone]="isProcessGroup() ? [] : ['task-v2']"
      (dndDrop)="onTaskDrop($event, 'created')"
    >
      <div dndPlaceholderRef class="dndPlaceholder"></div>

      @for (task of getTargetCollection('created'); track task.id) {
        <list-tasks-v2-single-task
          [task]="task"
          [groupId]="group().taskGroup.id"
          [isProcessGroup]="isProcessGroup()"
          status="created"
          (statusUpdated)="onTaskStatusChanged($event)"
          (taskClicked)="onTaskClicked($event)"
        />
      }

      <div
        class="d-flex flex-column list-tasks-group__completed"
        [ngClass]="{ hidden: !getTargetCollection('completed').length }"
      >
        <h5 class="list-tasks-group__content__completed-title">Completed</h5>

        <div [dndDropzone]="isProcessGroup() ? [] : ['task-v2']" (dndDrop)="onTaskDrop($event, 'completed')">
          <div dndPlaceholderRef class="dndPlaceholder"></div>

          @for (task of getTargetCollection('completed'); track task.id) {
            <list-tasks-v2-single-task
              [task]="task"
              [groupId]="group().taskGroup.id"
              [isProcessGroup]="isProcessGroup()"
              status="completed"
              (statusUpdated)="onTaskStatusChanged($event)"
              (taskClicked)="onTaskClicked($event)"
            />
          }
        </div>
      </div>

      <div
        class="d-flex flex-column list-tasks-group__cancelled"
        [ngClass]="{ hidden: !getTargetCollection('cancelled').length }"
      >
        <h5 class="list-tasks-group__content__cancelled-title">Cancelled</h5>

        <div [dndDropzone]="isProcessGroup() ? [] : ['task-v2']" (dndDrop)="onTaskDrop($event, 'cancelled')">
          <div dndPlaceholderRef class="dndPlaceholder"></div>

          @for (task of getTargetCollection('cancelled'); track task.id) {
            <list-tasks-v2-single-task
              [task]="task"
              [groupId]="group().taskGroup.id"
              [isProcessGroup]="isProcessGroup()"
              status="cancelled"
              (statusUpdated)="onTaskStatusChanged($event)"
              (taskClicked)="onTaskClicked($event)"
            />
          }
        </div>
      </div>
    </div>
  </div>
</div>
